import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Logger } from '@service/logger.service';
import { AuthenticationService } from '../service/authentication.service';

import { environment } from '../../../environments/environment';

const log: Logger = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (window.parent.length > 0) {
      // bypass for iframe
      return true;
    } else if (state.url.startsWith('/document')) {
      return this.checkDocumentAuth();
    }

    this.router.navigate(['renewal']);
    return false;
  }

  checkDocumentAuth(): boolean {
    if (this.authenticationService.currentUser) {
      return true;
    } else {
      this.router.navigate([`renewal`]);
      return false;
    }
  }
}
